import { createSlice } from "@reduxjs/toolkit";
const instailConst = {
  isAuthenticated: false,
  roles: [""],
  route: [],
  navbarList: [],
  reportList: [],
  user: {
    username: "none",
    details: {
      username: "",
      email: "",
      roles: null,
    },
  },
  masquerade: {
    isIt: false,
    p_logged_in_email: "",
    p_session: "",
    p_ticket_id: "",
  },
};
const initialState = localStorage.getItem("authentication")
  ? JSON.parse(localStorage.getItem("authentication"))
  : instailConst;

export const RS_Authentication = createSlice({
  name: "rs-authentication",
  initialState,
  reducers: {
    AuthenticateBasic: (state) => {
      state.isAuthenticated = true;
    },
    revokeAuthentication: (state) => {
      return instailConst;
    },
    Authenticate: (state, action) => {
      state.isAuthenticated = action.payload.isAuthenticated;
      state.user = action.payload.user;
      state.roles = action.payload.roles;
      localStorage.setItem("authentication", JSON.stringify(state));
    },
    setAuthRole: (state, action) => {
      state.roles = action.payload;
      localStorage.setItem("authentication", JSON.stringify(state));
    },
    setRoute: (state, action) => {
      state.route = action.payload;
      localStorage.setItem("authentication", JSON.stringify(state));
    },
    setReportList: (state, action) => {
      state.reportList = action.payload;
      localStorage.setItem("authentication", JSON.stringify(state));
    },
    setNavbarList: (state, action) => {
      state.navbarList = action.payload;
      localStorage.setItem("authentication", JSON.stringify(state));
    },
    setMasquerade: (state, action) => {
      state.masquerade = action.payload;
      localStorage.setItem("authentication", JSON.stringify(state));
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  AuthenticateBasic,
  revokeAuthentication,
  Authenticate,
  setAuthRole,
  setNavbarList,
  setRoute,
  setReportList,
  setMasquerade,
} = RS_Authentication.actions;

export default RS_Authentication.reducer;
